import BarCharts from './barCharts';
import { connect } from 'react-redux';
import { redux } from '../../api';
import { setHeatmapContextData } from '../../store';
import qs from 'query-string';

const { setAiScoresData } = redux.actions;

const mapStateToProps = state => {
  const imageData = state.ui.imageData;
  let imageReady = false;
  Object.keys(imageData).forEach(k => {
    if (imageData[k].image) imageReady = true;
  });

  const viewportIndex = state.viewports.activeViewportIndex;
  const viewportData = state.viewports.viewportSpecificData[viewportIndex];
  const objectUid = viewportData && viewportData.sopInstanceUid;
  const scores = state.api.scores.scores;
  const aiProductDetailInfo = state.api.current.aiProductDetailInfo || [];
  const thumbIndex = parseInt(window.localStorage.getItem('thumbIndex') || 0);
  let scoresData;
  if (qs.parse(window.location.search).from === 'aiproduct') {
    aiProductDetailInfo[thumbIndex] = aiProductDetailInfo[thumbIndex] || {};
    scoresData = {};
    scoresData.scores = aiProductDetailInfo[thumbIndex].ais;
  } else {
    scoresData = scores.find(s => s.objectUid === objectUid);
  }
  return {
    imageReady,
    scoresData,
    objectUid,
    context: state.ui.heatmapContext,
    thumbIndex,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setScoresData: data => {
      dispatch(setAiScoresData(data));
    },
    setHeatmapContext: data => {
      dispatch(setHeatmapContextData(data));
    },
  };
};

const ConnectedBarCharts = connect(
  mapStateToProps,
  mapDispatchToProps
)(BarCharts);

export default ConnectedBarCharts;
